import { render, staticRenderFns } from "./entity-list.vue?vue&type=template&id=1c405d60&scoped=true&"
import script from "./entity-list.vue?vue&type=script&lang=ts&"
export * from "./entity-list.vue?vue&type=script&lang=ts&"
import style0 from "./entity-list.vue?vue&type=style&index=0&id=1c405d60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c405d60",
  null
  
)

export default component.exports